// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34zTz","badges":"styles_badges__1eL9t"};